var omitsis = omitsis || {};
omitsis.scroll = omitsis.scroll || {};

(function() {
    var links = document.querySelectorAll('a[href*="#"]');

    for (var i = 0; i < links.length; i++) {
        links[i].onclick = function(e) {

            let el = document.querySelectorAll('a[name="' + this.getAttribute("href").substring(1) + '"]')[0];

            if (el) {

                e.preventDefault();

                window.scrollTo({
                    top: window.scrollY + el.getBoundingClientRect().top - 100,
                    behavior: "smooth"
                });
            }

        };
    }
})();


document.addEventListener('DOMContentLoaded', function(event) {
    omitsis.scroll.storeScroll();
    omitsis.add_click_events();
    omitsis.add_extra_clicks();
}, false);


window.addEventListener('scroll', function(event) {
    omitsis.scroll.debounce(omitsis.scroll.storeScroll())
}, false);


window.addEventListener('load', function(event) {
    document.body.classList.remove('no-transitions');
}, false);


omitsis.add_click_events = function() {
    omitsis.add_menu_events();
    document.addEventListener('click', function(event) {

        if (event.target.matches('.back-button')) {
            event.preventDefault();
            window.history.back();
        }

    }, false);
}

omitsis.add_menu_events = function() {
    document.querySelectorAll('.site-header__menu .nav__item--level-0 > a').forEach(function(element) {
        if (element.classList.contains('nav__link--has-children')) {
            element.open_submenu = function(_event) {
                _event.preventDefault();
                const navItem = _event.target.closest('.nav__item--has-children');
                if (!navItem.classList.contains('is-selected')) {
                    const navList = navItem.closest('.nav__list');
                    navList.querySelectorAll('.nav__item--has-children.is-selected').forEach(function(item) {
                        item.classList.remove('is-selected');
                    })
                }
                navItem.classList.toggle('is-selected');
            }
            element.addEventListener('mouseenter', function(event) {
                if (window.innerWidth >= 768) {
                    element.open_submenu(event);
                }
            });
            element.addEventListener('click', function(event) {
                if (window.innerWidth < 768) {
                    element.open_submenu(event);
                }
            });
        } else {
            element.addEventListener('mouseenter', function(event) {
                if (window.innerWidth >= 768) {
                    event.preventDefault();
                    document.querySelectorAll('.site-header__menu .nav__item--level-0.is-selected').forEach(function(element) {
                        element.classList.remove('is-selected');
                    });
                }
            });
        }
    });
    document.querySelectorAll('.site-header__menu .nav__list--level-1').forEach(function(element) {
        element.addEventListener('mouseleave', function(event) {
            if (window.innerWidth >= 768) {
                event.preventDefault();
                element.parentNode.classList.remove('is-selected');
            }
        });
    });

    document.querySelector('.site-header__menu-launcher-link').addEventListener('click', function(event) {
        event.preventDefault();
        document.body.classList.toggle('is-main-menu-visible');
        if (window.innerWidth < 768) {
            omitsis.scroll.change_scrollbar('toggle');
        }
    });

    document.querySelector('button.hamburger').addEventListener('click', function(event) {
        document.body.classList.toggle('is-main-menu-visible');
        omitsis.scroll.change_scrollbar('toggle');
    });


    document.querySelectorAll('.site-header__item--language-selector').forEach(function(item) {
        const clone = item.cloneNode(true);
        document.querySelector('.site-header__menu').appendChild(clone);
    });
}


omitsis.add_extra_clicks = function() {
    document.querySelectorAll('.add_link').forEach(function(item) {
        if (undefined !== item.dataset.link) {
            item.addEventListener('click', function(event) {
                event.preventDefault();
                window.location.href = item.dataset.link;
            }, false);
            item.style.cursor = 'pointer';
        }
    });
}


omitsis.scroll.debounce = function(fn) {
    // This holds the requestAnimationFrame reference, so we can cancel it if we wish
    let frame;

    // The debounce function returns a new function that can receive a variable number of arguments
    return (...params) => {
        // If the frame variable has been defined, clear it now, and queue for next frame
        if (frame) {
            cancelAnimationFrame(frame);
        }

        // Queue our function call for the next frame
        frame = requestAnimationFrame(() => {
            // Call our function and pass any params we received
            fn(...params);
        });
    };
};


omitsis.scroll.storeScroll = () => {
    document.documentElement.dataset.scroll = window.scrollY;
    if (window.scrollY > 100) {
        document.body.classList.add('is-scrolled');
    }
    if (window.scrollY === 0) {
        document.body.classList.remove('is-scrolled');
    }
};


omitsis.scroll.change_scrollbar = function(_action) {
    if (_action == 'hide') {
        var _with_scroll_width = document.body.clientWidth;
        document.body.style.overflow = 'hidden';
        document.body.style.marginRight = (document.body.clientWidth - _with_scroll_width) + 'px';
    }
    if (_action == 'show') {
        document.body.style.overflow = 'visible';
        document.body.style.marginRight = '0px';
    }
    if (_action == 'toggle') {
        if (document.body.style.overflow == 'hidden') {
            omitsis.scroll.change_scrollbar('show');
        } else {
            omitsis.scroll.change_scrollbar('hide');
        }
    }
}

function waveAuditFixes() {
    //fix contrast

    const selectors = [
        '.nice-button__label',
        '.cky-btn:not(.cky-btn-accept)',
        '.conrad-tulum-resource-slider__item-category-item',
        '.conrad-tulum-heading-text__category-item',
        '.hover-resource-card__title',
        '.hover-resource-card__description',
        '.conrad-tulum-image-text__category-item',
        '.resort-point__mark--inner',
        '.resort__map--legend--row--main-title',
        '.resort__map--legend--row--item--num--text',
        '.conrad-tulum-amenities__item',
        '.conrad-tulum-accommodation-search__title',
        '.conrad-tulum-accommodation-search__description',
        '.site-header__menu-launcher-link',
        '.conrad-tulum-chart-data__table > thead > tr > th',
        '.conrad-tulum-chart-data__table > thead.conrad-tulum-chart-data__table-head > tr > td',
        '.resource__item-category-item',
        '.accommodation-card__category-item',
        '.itinerary-card__category-item',
    ].join(', ');

    const elements = document.querySelectorAll(selectors);

    elements.forEach(function(element) {
        element.style.backgroundColor = 'rgba(0,0,0,0.009)';
    });

    var acceptButton = document.querySelector('.cky-btn-accept');
    if (acceptButton) {
        acceptButton.style.backgroundColor = '#8B714D';
        acceptButton.style.borderColor = '#8B714D';
    }
}

document.addEventListener('DOMContentLoaded', function() {
    waveAuditFixes();
});